import { mapGetters } from 'vuex';
import { errorMessage } from '@/utils/message.js';
import ForgetPasswordService from '../forget-password-service.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      processList: ['验证身份', '重置密码', '重置成功'],
      step: 2,
      form: {
        mobile: '',
        originalPassWord: '',
        newPassWord: '',
        userType: ''
      },
      rules: {
        originalPassWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        newPassWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
    this.form.mobile = this.$route.query.mobile;
    this.form.userType = this.$route.query.userType;
  },
  methods: {
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    // 上一步
    frontStep() {
      this.$router.back();
    },
    // 下一步
    secondStep() {
      if (!this.validateForm()) { return; };
      ForgetPasswordService.updatePassWord(this.form).then(res => {
        if (res && res.code === '0') {
          this.$router.push('/forget-password/amend-success');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
